import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import StatusDot from '../status/StatusDot';

/**
 * T13.3 — custom node renderers. Memoized: graph re-renders must not
 * cascade into node bodies (perf guard, T13.7 pairs with edge animation).
 * Internal components use a Base suffix to avoid clashing with the
 * memoized export names.
 */

function OrchestratorNodeBase({ data }) {
  const statusToken = data.status === 'autonomous' ? 'autonomous' : data.status;

  return (
    <div className="brain-node brain-node--orchestrator">
      <Handle position={Position.Bottom} type="source" />
      <span className="brain-node__status"><StatusDot status={statusToken} pulse={data.status === 'running'} /></span>
      <strong>{data.name}</strong>
      <small>{data.role}</small>
      {data.stats && (
        <em>{data.stats.decisions.toLocaleString()} decisions · {Math.round(data.stats.autonomy * 100)}% autonomous</em>
      )}
    </div>
  );
}

function SubAgentNodeBase({ data }) {
  const statusToken = data.status === 'autonomous' ? 'autonomous' : data.status;

  return (
    <div className="brain-node brain-node--sub">
      <Handle position={Position.Top} type="target" />
      <Handle position={Position.Bottom} type="source" />
      <span className="brain-node__status"><StatusDot status={statusToken} pulse={data.status === 'running'} /></span>
      <strong>{data.name}</strong>
      <small>{data.role}</small>
    </div>
  );
}

function ToolNodeBase({ data }) {
  return (
    <div className="brain-node brain-node--tool">
      <Handle position={Position.Top} type="target" />
      <strong>{data.name}</strong>
    </div>
  );
}

export const OrchestratorNode = memo(OrchestratorNodeBase);
export const SubAgentNode = memo(SubAgentNodeBase);
export const ToolNode = memo(ToolNodeBase);

export const NODE_TYPES = {
  orchestrator: OrchestratorNode,
  subAgent: SubAgentNode,
  tool: ToolNode
};
